import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const AppProviders = lazy(() => import('@app/components/AppProviders'))
const ActivityToast = lazy(() => import('.'))

class ActivityToastWebComponent extends ReactWebComponent {
  override render() {
    return (
      <AppProviders>
        <ActivityToast />
      </AppProviders>
    )
  }
}

customElements.define('activity-toast', ActivityToastWebComponent)
